<div class="unsuitable-main-container">
    <div class="dish_name_heading">{{dishName}}</div>
    <div class="horizontal_line_div">&nbsp;</div>
    <div *ngIf="allergensData.length > 0 && dpData.length > 0;else singleNotSuitable" class="unsuitable_reason_txt">
        Dish is not suitable because it has following
    </div>
    <ng-template #singleNotSuitable>
        <div *ngIf="allergensData.length > 0" class="unsuitable_reason_txt">
            Dish is not suitable because it has following allergen
        </div>
        <div *ngIf="dpData.length > 0" class="unsuitable_reason_txt">
            Dish is not suitable because it has following dietary preference
        </div>
    </ng-template>
    <div *ngIf="allergensData.length > 0 && dpData.length > 0;" class="seprate_header">
        <li>Allergen</li>
    </div>

    <div class="all_allergens_list_main_div" *ngIf="allergensData.length > 0">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th scope="col-1">Allergens</th>
                    <th scope="col-1">Option Available</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of allergensData">
                    <tr>
                        <th scope="row">
                            <div class="allergen_list_ele">{{item.allergens_name}}</div>
                        </th>
                        <td>
                            <div class="allergen_list_ele">{{item.is_allergens_option ? 'Yes' : 'No'}}</div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>


    <div *ngIf="allergensData.length > 0 && dpData.length > 0;" class="seprate_header">
        <li>Dietary Preference</li>
    </div>
    <div class="all_allergens_list_main_div" *ngIf="dpData.length > 0">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th scope="col-1">Dietary Preference</th>
                    <th scope="col-1">Option Available</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of dpData">
                    <tr>
                        <th scope="row">
                            <div class="allergen_list_ele">{{item.diet_preference_name}}</div>
                        </th>
                        <td>
                            <div class="allergen_list_ele">{{item.is_dietary_option ? 'Yes' : 'No'}}</div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

</div>











<style>
    ::ng-deep .mat-bottom-sheet-container {
        padding: 0px !important;
        box-sizing: border-box;
        display: block;
        outline: 0;
        max-height: 600vh !important;
        overflow: visible !important;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    ::ng-deep.mat-bottom-sheet-container-large {
        min-width: 380px;
        max-width: 380px;
    }

    ::ng-deep.mat-bottom-sheet-container-xlarge {
        min-width: 380px !important;
        max-width: 380px;
    }

    .unsuitable-main-container {
        max-height: 400px;
        overflow: scroll;
        position: relative;
        display: flex;
        flex-direction: column;
        min-height: 200px;
        padding-bottom: 10px;
    }

    .dish_name_heading {
        color: #54AC58;
        font-weight: 500;
        font-size: 18px;
        padding: 15px 0;
        text-align: center;
        text-transform: capitalize;
    }

    .horizontal_line_div {
        margin: 0 10px;
        background-color: #EFEFEF;
        height: 3px;
        /* width: 100%; */
    }

    .unsuitable_reason_txt {
        margin: 10px;
        font-size: 15px;
        font-weight: 500;
    }


    .all_allergens_list_main_div {
        flex: 1;
        overflow: auto;
        padding-top: 10px;
        /* padding-left: 2rem; */
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 10px;
    }

    .allergen_list_ele {
        /* margin-bottom: 10px; */
        color: #707070;
        font-size: 14px;
    }

    .all_allergens_list_main_div .table th,
    .all_allergens_list_main_div .table td {
        width: 50%;
        text-align: center;
    }

    .seprate_header {
        margin: 0 11px;
        font-weight: 500;
    }
</style>